<template>
  <div >
    <b-spinner v-if="!dataLoaded" variant="success" label="Spinning"></b-spinner>
    <b-alert :show="dataLoaded && error" variant="danger">{{errorText}}</b-alert>
    <div>
      <b-row class="my-1" v-if="activeDataset" >
        <b-col sm="8">
          <b-form-input class="passwordInput" v-model="password" type="password" placeholder="Please enter password"></b-form-input>
        </b-col>
        <b-col sm="4">
          <b-button v-on:click="triggerTraining">Confirm</b-button>
        </b-col>
      </b-row>
      <b-row class="my-1" v-if="showAlert">
        <b-col sm="12">
          <b-alert show variant="danger" dismissible>{{alertText}}</b-alert>
        </b-col>
      </b-row>
    </div>
    <table class="table  table-responsive" v-if="dataLoaded">
      <thead >
        <tr>
          <th scope="col">Prediction Config</th>
          <th class="clickable" v-for="dataset in successStats.datasets"  scope="col" v-on:click="copyDatasetNumber(dataset)">
            <span :id="dataset + ''" >{{'..' + (dataset + "").substr((dataset+ "").length - 3,3)}}</span>
            <b-tooltip :target="dataset + ''" >
              {{dataset + ''}}
            </b-tooltip>
            <i v-on:click="copyDatasetNumber(dataset)" class="material-icons icon-mini md-24 clickable">file_copy</i>
            <i :id="dataset + 'retrain'" v-on:click="activeDataset = dataset; showAlert = false" class="material-icons icon-mini md-24 clickable">send</i>
            <b-tooltip :target="dataset + 'retrain'" >
              {{'Retrain dataset ' + dataset}}
            </b-tooltip>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluation in successStats.evaluations">
          <td class="clickable" v-on:click="goToPredictionConfig(evaluation.configName)">{{evaluation.configName}}</td>
          <td v-for="dataset in successStats.datasets">
            <div v-if="evaluation.datasets[dataset]">
              <span v-if="!predictionSettings" :class="getReportClass(evaluation.datasets[dataset])" @click="openReport(evaluation.configName, dataset)">{{evaluation.datasets[dataset].winPercentage}}</span>
              <span v-if="predictionSettings" :class="getReportClass(evaluation.datasets[dataset]) + ' blah ' + isCurrent(dataset, evaluation.configName)" @click="openReport(evaluation.configName, dataset)">{{evaluation.datasets[dataset].winPercentage}}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SuccessByDatasetForTagVersion from '../models/SuccessByDatasetForTagVersion'
import * as TasksClient from '../clients/TasksClient'
import * as ConfigurationClient from '../clients/ConfigurationClient'
export default {
  name: 'EvaluationsByTagVersionTable',
  props: ['tagVersion', 'type'],
  data () {
    return {
      title: 'EvaluationsByTagVersionTable',
      successStats: {},
      dataLoaded: false,
      activeDataset: undefined,
      showAlert: false,
      password: undefined,
      alertText: "Password incorrect",
      errorText: "Failed to load evaluations",
      error: false,
      predictionSettings: undefined
    }
  },
  methods: {
    getReportClass(dataset) {
      if (dataset && dataset.report) return "clickable has-report"
    },
    copyDatasetNumber (number) {
      const el = document.createElement('textarea');
     el.value = number;
     el.setAttribute('readonly', '');
     el.style.position = 'absolute';
     el.style.left = '-9999px';
     document.body.appendChild(el);
     el.select();
     document.execCommand('copy');
     document.body.removeChild(el);
   },
    goToPredictionConfig: function(name) {
      this.$router.push({name:'PredictionConfig', params: {configId: name}})
    },
    loadSuccessByTagVersion: async function()  {
      if (this.type) {
        var query = [{type: this.type}]
      }
      this.dataLoaded = false
      this.error = false
      var stats = new SuccessByDatasetForTagVersion()
      try {
        await stats.load(this.tagVersion, query)
        await stats.addReportFlags()
        this.successStats = stats
        this.dataLoaded = true
      }catch(err) {
        this.dataLoaded = true
        this.error = true
        this.errorText = "Failed to load evaluations"
      }

      try {
        var predictionSettingsResponse = await ConfigurationClient.getPredictionSettings()
        this.predictionSettings = predictionSettingsResponse.data
      }catch (err) {
        console.log(err)
        if (!this.error) {
          this.error = true
          this.errorText = "Failed to load prediction settings"
        }
      }
    },
    isCurrent: function (dataset, configName) {
      return (dataset === this.predictionSettings.datasetNumber && configName === this.predictionSettings.predictionConfig)? "active-config"
 : ""    },
    triggerTraining: function() {
      TasksClient.triggerTraining(this.activeDataset, this.password)
      .then(response => {
        this.activeDataset = undefined
        this.showAlert = false
      })
      .catch (err => {
        if (err.response.status === 403) {
          this.alertText = "Password incorrect"
          this.showAlert = true
          this.evaluationTriggersInProgress[this.activeDataset] = false
          this.evaluationsTriggered[this.activeDataset] = false
        }else {
          if (err.response.status === 409) {
            this.showAlert = true
            this.alertText = "Training already running for dataset"
            this.activeDataset = undefined
          }
        }
      })
    },
    openReport: function(configName, datasetNumber) {
      console.log("Opening " + configName + " " + datasetNumber)
      this.$router.push({name: "Report", params: {configName: configName, datasetNumber: datasetNumber}})
    }
  },
  mounted () {
    this.loadSuccessByTagVersion (this.tagVersion)
  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.has-report {
  text-decoration: underline;
  font-weight: bold;
}

.icon-mini {
  font-size: 12px !important
}

.active-config {
  color: #05965a
}

</style>
